export enum UserActions {
  Toggled = 'toggled',
  PageChange = 'pageChange'
}